/**
 * Parse `document.cookie` for a named cookie. HttpOnly cookies are not visible to script.
 * Cookies for another origin (e.g. API host when the SPA runs elsewhere) do not appear in
 * `document.cookie` for the page origin.
 */

export function getCookie(name: string): string | undefined {
  if (typeof document === 'undefined') {
    return undefined
  }
  const prefix = `${name}=`
  for (const part of document.cookie.split(';')) {
    const trimmed = part.trim()
    if (!trimmed.startsWith(prefix)) {
      continue
    }
    let value = trimmed.slice(prefix.length)
    if (value.startsWith('"') && value.endsWith('"') && value.length >= 2) {
      value = value.slice(1, -1)
    }
    return value
  }
  return undefined
}
